import { useState, useEffect } from "react";
import { mobileViewLinks } from "../constants";
import { useLocation } from "react-router-dom";
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  const location = useLocation();
  const [isMobileLink, setIsMobileLink] = useState(false);
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  useEffect(() => {
    setIsMobileLink(
      mobileViewLinks.some((link) => link === location.pathname.split("/")[1])
    );
  }, [location.pathname]);

  return { windowSize, isMobile: windowSize.width <= 992, isMobileLink };
}

export default useWindowSize;
